import RepositoryError from "repository/error/RepositoryError";

export default class FailedRequestError extends RepositoryError {
    constructor(message) {
        super(`Failed Request: ${message}`);
    }
}